import { Link } from "react-router-dom";
import { format, parseISO } from "date-fns";
import { de } from "date-fns/locale";
import type { PostDto } from "@/types";
import { ResponsiveImage } from "@/components/content/ResponsiveImage";

export function PostCard({ post }: { post: PostDto }) {
  const locale = de;
  return (
    <article className="flex flex-col bg-bg border border-border rounded-lg overflow-hidden card-hover">
      <Link to={`/aktuelles/${post.slug}`} className="block aspect-[16/9] bg-bg-muted overflow-hidden">
        {post.coverImage ? (
          <ResponsiveImage media={post.coverImage} sizes="(min-width: 1024px) 30vw, (min-width: 768px) 45vw, 90vw" className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full bg-primary-soft flex items-center justify-center text-primary text-3xl font-serif">
            {post.title.charAt(0)}
          </div>
        )}
      </Link>
      <div className="p-5 flex-1 flex flex-col gap-2">
        <div className="text-xs uppercase tracking-wide text-text-muted flex items-center gap-2">
          {post.publishedAt && <time>{format(parseISO(post.publishedAt), "d. MMMM yyyy", { locale })}</time>}
          {post.category && (
            <span className="bg-primary/10 text-primary px-2 py-0.5 rounded">{post.category}</span>
          )}
        </div>
        <h3 className="text-lg font-bold leading-snug">
          <Link to={`/aktuelles/${post.slug}`} className="hover:text-primary">{post.title}</Link>
        </h3>
        {post.excerpt && <p className="text-text-muted text-sm flex-1">{post.excerpt}</p>}
        <Link to={`/aktuelles/${post.slug}`} className="text-sm font-medium text-primary hover:underline mt-2">
          {"Weiterlesen"} -&gt;
        </Link>
      </div>
    </article>
  );
}
